/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import React, { useState } from 'react';

import Tooltip from 'src/components/general/Tooltip';

export const IconTooltip = ({
  title,
  children,
  displayInline = false,
}: {
  /**
   * Pass in text or html wrapped in a React.Fragment to be displayed
   * as the tooltip when the user hovers over the info icon.
   */
  title: React.ReactNode;

  /** Content to render before the tooltip icon */
  children?: React.ReactNode;

  /** When true, the wrapper will be displayed as inline-block instead of block */
  displayInline?: boolean;
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = () => setShowTooltip(true);
  const handleMouseLeave = () => setShowTooltip(false);

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onFocus={handleMouseEnter}
      onBlur={handleMouseLeave}
      css={[wrapperStyles, displayInline ? inlineStyles : undefined]}
    >
      {children}
      <Tooltip title={<>{title}</>} placement="bottom-start" interactive>
        <InfoIcon css={[iconStyles, showTooltip ? visibleStyles : undefined]} />
      </Tooltip>
    </div>
  );
};

const wrapperStyles = css`
  display: block;
  position: relative;
`;

const inlineStyles = css`
  display: inline-block;
`;

const iconStyles = css`
  color: #90caf9; /* theme.palette.secondary.light fallback, can be adjusted if needed */
  visibility: hidden;
  opacity: 0;
  transition:
    visibility 0.2s linear,
    opacity 0.2s linear;
  position: absolute;
  right: 100%;
  top: 10px;
`;

const visibleStyles = css`
  visibility: visible;
  opacity: 1;
`;
